export default __webpack_public_path__ + "static/media/header-logo.d820575c.svg";